enum errorTypes {
    BESTILL_VERDIVURDEING = 'Bestill verdivurdering',
    DELETE_BARN = 'Delete barn',
    DELETE_BIL = 'Delete bil',
    DELETE_EIENDOM = 'Delete eiendom',
    DELETE_GJELD = 'Delete gjeld',
    DELETE_INNTEKT = 'Delete inntekt',
    DELETE_SOEKNAD = 'Delete soeknad',
    DELETE_VEDLEGG = 'Delete vedlegg',
    FIND_EIENDOMSVERDI = 'Find eiendomsverdi',
    FIND_SOEKNAD = 'Find soeknad',
    FIND_BASIC_SOEKNAD = 'Find basic soeknad',
    GET_ADRESSER = 'Get adresser',
    GET_BARN = 'Get barn',
    GET_BIL = 'Get bil',
    GET_GEO_OMRAADE = 'Get GeoOmraade',
    GET_EIENDOMSREGISTER = 'Get eiendomsregister',
    GET_EIENDOMSVERDI = 'Get eiendomsverdi',
    GET_EGENKAPITAL = 'Get egenkapital',
    GET_ETAKST = 'Get eTakst',
    GET_POSTSTED = 'Get poststed',
    GET_ENGASJEMENT = 'Get engasjement',
    GET_FEATURE_TOGGLES = 'Get feature toggles',
    GET_GJELD = 'Get gjeld',
    GET_INNTEKT = 'Get inntekt',
    GET_KJOERETOEY = 'Get kjoeretoey',
    GET_LEIEINNTEKT = 'Get leieinntekt',
    GET_KONTAKTINFORMASJON = 'Get kontaktinformasjon',
    GET_PERSONNAVN = 'Get personnavn',
    GET_SAMTYKKE_URL = 'Get samtykkeurl',
    GET_SOEKNAD_LAAN = 'Get soeknad laan',
    GET_KVITTERING_INFO = 'Get kvittering info',
    GET_VEDLEGG = 'Get vedlegg',
    REQUEST_VERDIVURDERING = 'Send verdivurdering request',
    SAVE_EGENKAPITAL = 'Save egenkapital',
    SAVE_INTERN_GJELD = 'Save intern gjeld',
    SAVE_SOEKNAD = 'Save soeknad',
    SAVE_TILBAKEMELDING = 'Save tilbakemelding',
    SEND_SOEKNAD = 'Send soeknad',
    UPDATE_BARN = 'Update barn',
    UPDATE_BIL = 'Update bil',
    UPDATE_EINDOMSVERDI = 'Update eiendomsverdi',
    UPDATE_GJELD = 'Update gjeld',
    UPDATE_INNTEKT = 'Update inntekt',
    UPDATE_LEIEINNTEKT = 'Update leieinntekt',
    UPDATE_LAANTAKERE = 'Update laantakere',
    UPDATE_KONTAKTINFORMASJON = 'Update kontaktinformasjon',
    UPDATE_SOEKNAD_LAAN = 'Update soeknad laan',
    UPLOAD_VEDLEGG = 'Upload vedlegg',
}

export default errorTypes;
